import { NOTICE_TONE_CLASSES } from "@/app/(app)/refer/_components/form-v2/styles";
import { cn } from "@/lib/utils";
import { CircleAlert, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";

/** A warning or error alert with an icon, as on the front-door design. */
export const FrontDoorNotice = ({
  tone,
  title,
  className,
  children,
}: {
  tone: "warning" | "error";
  title?: string;
  className?: string;
  children: ReactNode;
}) => {
  const Icon = tone === "warning" ? CircleAlert : TriangleAlert;
  return (
    <div
      role="alert"
      className={cn(
        "flex gap-3 rounded-xl border px-4 py-3.5 text-sm leading-normal",
        NOTICE_TONE_CLASSES[tone],
        className,
      )}
    >
      <Icon className="mt-0.5 h-[18px] w-[18px] shrink-0" aria-hidden />
      <div>
        {title && <strong className="mb-0.5 block">{title}</strong>}
        {children}
      </div>
    </div>
  );
};
